import React, { useEffect } from 'react';
import bountyRequestDone from '../../assets/bountyRequestDone.png';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
const RequestCreated = ({ isFundingRequested }) => {
    const navigate = useNavigate();
    useEffect(function () {
        const timeoutId = setTimeout(() => {
            navigate(-1);
            toast.success(
                isFundingRequested
                    ? 'Bounty is now live on the ‘Impact Landscapes’ App!'
                    : 'Bounty is now live on the ‘Impact Miner’ App!'
            );
        }, '1000');
        return () => clearTimeout(timeoutId);
    }, []);
    return (
        <div className="flex items-center h-[90vh] justify-center">
            <div className="">
                {/* <p className="text-3xl font-semibold text-lightBlack">Bounty is being sent for treasury approval</p> */}
                <p className="text-3xl font-semibold text-lightBlack">
                    {' '}
                    {isFundingRequested
                        ? 'Funding request has been submitted to Impact Landscapes!'
                        : 'Bounty is being published'}{' '}
                </p>
                <div className="flex items-center justify-center">
                    <img src={bountyRequestDone} alt="" />
                </div>
            </div>
        </div>
    );
};

export default RequestCreated;
